import { CLIENTS } from "/src/constants/config";
import { getclientBodyClass } from "/src/config/utils";

const main = {
  apiUrl: "https://api-adler.vigitalsolutions.com",
  frontendUrl: "https://adler.vigitalsolutions.com/frontend",
  videoUrl: "https://video.spovizz.com",
  client: CLIENTS.ADLER,
};

const config = {
  ...main,
  testMode: false,
  appName: "Spo|Vizz",
  screenshotsUrl: `${main.apiUrl}/screenshots/[[TEMPLATE]]/[[UUID]]/[[TYPE]].jpg`,
  chatbox: {
    active: false,
  },
  refreshVideoInterval: 10000,
  dashboardTemplatesRefreshInterval: 5000,
  clientBodyClass: getclientBodyClass(main.client),
};

export default config;
